import logo from '../../assets/images/express-logo.png'

export default function FallbackPage() {
    return (
        <>
            <div className="d-flex justify-content-center align-items-center" style={{ backgroundColor: '#FCF8FA', height: '100vh' }}>
                <div className="text-white text-center">
                    <img src={logo} alt="lg" className="img-fluid zoom-animation" />
                </div>
            </div>
        </>
    )
}